import { Grid, Typography } from '@mui/material';

import formatNumber from '@/utils/formatNumber';

// @ts-expect-error - js module
import useIsHistoricalData from './hooks/useIsHistoricalData';

type Props = {
  isComplete: boolean;
  svuValue: number;
  numGoals: number;
};

export default function AllGoalsCompletionAwardBanner({
  isComplete,
  svuValue,
  numGoals,
}: Props) {
  const isHistorical = useIsHistoricalData();
  let textWidget;
  let bgColor = 'background.primaryMidnight';
  const formattedSvuValue = formatNumber(svuValue);
  const goalText = numGoals === 1 ? 'your goal' : 'all goals';
  if (isComplete) {
    bgColor = 'colorPool.emerald.500';
    textWidget = (
      <Typography variant="metricmedium" color="text.primaryInverse">
        You earned{' '}
        <Typography
          color="colorPool.orange.50"
          variant="metricmediumbold"
          whiteSpace="nowrap"
        >
          {formattedSvuValue} Bonus SVUs
        </Typography>{' '}
        for completing {goalText}!
      </Typography>
    );
  } else if (isHistorical) {
    // If historical, and we didn't complete all goals, we don't show the banner
    return null;
  } else {
    textWidget = (
      <Typography variant="metricmedium" color="text.primaryInverse">
        Complete {goalText} to earn{' '}
        <Typography
          color="colorPool.orange.50"
          variant="metricmediumbold"
          whiteSpace="nowrap"
        >
          {formattedSvuValue} Bonus SVUs
        </Typography>
      </Typography>
    );
  }
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      bgcolor={bgColor}
      borderRadius={2}
      border="1px solid"
      borderColor="background.base"
      justifyContent="center"
    >
      <Grid item xs={3}>
        <span style={{ padding: '0 .5rem' }}>{textWidget}</span>
      </Grid>
    </Grid>
  );
}
